export default "__VITE_ASSET__BwFsoUm5__"